import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { JobMonitorScreen } from "../../features/jobs/job-monitor-screen";

export function createJobsRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "jobs",
    element: <JobMonitorScreen dependencies={dependencies} />,
  };
}
